import React from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonCard, IonCardTitle, IonCardHeader, IonCardContent, IonItem, IonLabel, IonInput, IonButton, IonRow, IonCol } from '@ionic/react'
import ReactDOM from "react-dom";
import CryptoJS from "crypto-js";
import App from '../../App';
import { getConfig, setConfig } from '../../resources/configSettings';
import ConfigContextProvider from '../../contexts/ConfigContext';
import AuthContextProvider from '../../contexts/AuthContext';


const Lisenced = () => {

    let config = getConfig()
    let key = atob(localStorage.getItem("netsession"));
    let ip = (localStorage.getItem("ipno"));
    let name = localStorage.getItem("name");

    if (!config.registrationDate) {
        config.registrationDate = Date();
    }

    config.lisencee = name;
    config.serial = atob(ip)
    config.productType = 'lisensed';
    setConfig(config)


    let hash = CryptoJS.SHA1(atob(ip) + name).toString();
    // console.log(hash)
    // console.log(key)

    if (ip && (key === hash)) {
        config.lisenced = true;
        setConfig(config);
    }

    const Apps = (
        <ConfigContextProvider>
            <AuthContextProvider>
                <App />
            </AuthContextProvider>
        </ConfigContextProvider>
    )

    const lisenseForm = (
        <IonPage >
            <IonHeader>
                <IonToolbar color='dark'>
                    <IonTitle>
                        Lisensing App
                    </IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent color='dark'>
                <IonRow>
                    <IonCol offset-md='3' size-md='6'>
                        <IonCard color='light'>
                            <IonCardHeader>
                                <IonCardTitle>Lisense Form</IonCardTitle>
                            </IonCardHeader>
                            <IonCardContent>
                                <h4>Serial No : {ip ? atob(ip) : (<a href='/login' onClick={() => window.location.reload()} >Click here to get serial no.</a>)}</h4>
                                <form >
                                    <IonItem color='light'>
                                        <IonLabel position='stacked'>Name</IonLabel>
                                        <IonInput required type='text' id='name' onIonChange={e => {
                                            localStorage.setItem("name", (e.target.value).trim());
                                            config.lisencee = localStorage.getItem('name');
                                            setConfig(config);
                                        }}></IonInput>
                                    </IonItem>
                                    <IonItem color='light'>
                                        <IonLabel position='stacked'>Key</IonLabel>
                                        <IonInput required type='password' id='key' onIonChange={e => {
                                            localStorage.setItem("netsession", btoa(e.target.value))
                                        }}></IonInput>
                                    </IonItem>
                                    <IonButton color='dark' type='submit'>Submit</IonButton>
                                </form>
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                </IonRow>
            </IonContent>
        </IonPage>
    )

    if (config.lisenced) {
        ReactDOM.render(Apps, document.getElementById("root"));
    } else {
        ReactDOM.render(lisenseForm, document.getElementById("root"));
    }


}

export default Lisenced
